import axios from 'axios';
import { toast } from 'react-toastify';
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from '../../index'; // Adjust the path as needed
import { apiRequest } from "../auth/msalConfig";

// Flag to prevent multiple redirects
let loginRedirectInProgress = false;

const axiosInstance = axios.create({
  baseURL: '/', // Replace with your base API URL
  headers: {
    'Content-Type': 'application/json',
  }
});

// Async request interceptor to attach token
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      // Get all accounts (assumes single account)
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        try {
          const response = await msalInstance.acquireTokenSilent({
            ...apiRequest,
            account: accounts[0],
          });
          config.headers.Authorization = `Bearer ${response.accessToken}`;
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            // Prevent multiple redirects
            if (!loginRedirectInProgress) {
              loginRedirectInProgress = true;
              await msalInstance.loginRedirect(apiRequest);
            }
            // Return a promise that never resolves - page will reload after redirect
            return new Promise(() => {});
          } else {
            console.error("Token acquisition failed:", error);
            throw error;
          }
        }
      } else {
        // No accounts found - allow request to proceed without auth for read-only mode
        // API endpoints should handle unauthorized requests appropriately
        // console.log("No authenticated user - proceeding in read-only mode");
      }
    } catch (err) {
      console.error("Failed to acquire token:", err);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - improved error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // If 401 unauthorized, let the request interceptor handle it on retry
    if (error?.response?.status === 401) {
      // Clear any stored tokens or user data
      localStorage.removeItem('currentUser');
      
      // If not already redirecting, trigger a new request which will
      // go through the request interceptor and handle auth
      if (!loginRedirectInProgress) {
        return axiosInstance(error.config);
      }
      return Promise.reject(error);
    }
    
    // Handle other errors
    const errorMessage = error?.response?.data?.error || 'An unexpected error occurred';
    toast.error(errorMessage);
    return Promise.reject(error);
  }
);

export default axiosInstance;